module.exports = __webpack_public_path__ + "img/inventory-log-book_B09Q8YLLZT.ef8197af.jpg";